var GatedContent = function(options) {
    this.options = {
        $el: false,
    };

    $.extend(true, this.options, options);

}

GatedContent.prototype.init = function() {
    var gatedContent = document.getElementById('content');
    if(gatedContent) {
        if (document.readyState === "loading") {
            window.location.hash = 'content';
        } else {
            window.location.hash = 'content';
        }
        
    }
}

export default GatedContent;